/*
 *
 * Copyright (c) 2020 TenderHub LLC. All rights reserved
 *
 * This software is the confidential and proprietary information of
 * TenderHub LLC ("Confidential Information"). You shall not disclose
 * such Confidential Information.
 *
 */
import './bootstrap';

// import { loadRemoteEntry } from '@angular-architects/module-federation';
//
// Promise.all([
// 	loadRemoteEntry('http://localhost:4211/remoteEntry.js', 'signon_users'),
// 	loadRemoteEntry('http://localhost:4213/remoteEntry.js', 'signon-public'),
// ])
// 	.catch((err) => console.error('Error loading remote entries', err))
// 	.then(() => import('./bootstrap'))
// 	.catch((err) => console.error(err));
